import React from "react";
import { ItemLine } from "./ItemLine";
import { Rate } from "@Shared/Components/Rate/Rate";
import messages from "../messages";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { useOrderDescription } from "../useOrderDescription";

export const Credits = ({ order }) => {
  const { promoCode, credit } = useOrderDescription(order);

  return (
    <>
      {credit.length > 0 && (
        <ItemLine
          title={<FormattedMessage {...messages.ringtwiceCredits} />}
          amount={
            <Rate
              cents={credit[0]?.amountCents}
              currency={order.itemsTotalCurrency}
            />
          }
          isSubstract
        />
      )}
      {promoCode.length > 0 && (
        <ItemLine
          title={<FormattedMessage {...messages.promoCodes} />}
          amount={
            <Rate
              cents={promoCode[0]?.amountCents}
              currency={order.itemsTotalCurrency}
            />
          }
          isSubstract
          style={{ borderTopWidth: 0, paddingTop: 0 }}
        />
      )}
    </>
  );
};
